import { render, staticRenderFns } from "./visit_profile.vue?vue&type=template&id=38bb0d92&"
import script from "./visit_profile.vue?vue&type=script&lang=js&"
export * from "./visit_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports